'use client';

import { FloatingOverlay } from '@floating-ui/react';
import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { PopoverRootContext } from './context/popover-root.context';
import { popoverBackdropRecipe } from './styles/popover-backdrop.styles';
import type { PopoverBackdropPropsInterface } from './types/popover-backdrop.types';

/**
 * @since 10.0.0
 */
export const PopoverBackdrop = forwardRef<HTMLDivElement, PopoverBackdropPropsInterface>(
  (props: PopoverBackdropPropsInterface, forwardedRef) => {
    const { modal, popover } = useContext(PopoverRootContext);
    const { children, className, css: cssProp, lockScroll = true, ...rest } = props;

    const styles = css(
      popoverBackdropRecipe.raw({
        modal,
        open: popover.transitionStatus === 'open',
      }),
      cssProp,
    );

    const Component = modal ? FloatingOverlay : 'div';

    return (
      <Component
        ref={forwardedRef}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="Popover.Backdrop"
        className={cx('c11n', 'c11n_popover__backdrop', styles, className)}
        {...(modal ? { lockScroll } : {})}
        {...rest}
      >
        {children}
      </Component>
    );
  },
);

PopoverBackdrop.displayName = 'Popover.Backdrop';
